import { useEffect, useRef, useState } from 'react';
import { useHistory, Link, useParams } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import styled from 'styled-components';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import { CreatedOnCell } from '../../../../components/common/grid/Cells';
import { transformLabels } from '../../../../utils/misc';
import FnbApi from '~/src/services/api/FnbApi';
import { StatusCodes } from 'http-status-codes';
import FnbPendingChange from '../components/FnbPendingChange';
import SyncFnbOrder from '../components/SyncFnbOrder';
import GridWrapper from '~/src/components/common/GridWrapper';
import SecondaryButton from '~/src/components/common/forms/Button/SecondaryButton';
import { ConsolidationFilter } from '~/src/components/common/grid/ConsolidationFilter';
import { PackageFilter } from '~/src/components/common/grid/PackageFilter'; 

export default function FnbConsolidationDetails(): JSX.Element {
  const stateRef = useRef(null);
  const { orderId } = useParams();
  const history = useHistory();
  const [addPendingChanges, setAddPendingChanges] = useState([]);
  const [removePendingChanges, setRemovePendingChanges] = useState([]);
  const url = `${API_URL}/fnb/get-for-consolidation/${orderId}`;
  const StatefullGrid = withState(Grid, url);
  
  const numberCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/orders/fnb/${dataItem.uniqueNumber}`}>{dataItem.uniqueNumber}</Link>
      </td>
    );
  };

  const orderNumberCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/orders/details/${dataItem?.order?.id}`} target="_blank">
          {dataItem?.order?.orderNumber}
        </Link>
      </td>
    );
  };

  const statusCell = (row) => {
    const { dataItem } = row;

    return <td>{transformLabels(dataItem.status)}</td>;
  };

  const actionCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        {!dataItem.consolidated ? (
          <SyncFnbOrder onUpdate={UpdateTable} dataItemId={dataItem.id} />
        ) : (
          <span>Consolidated</span>
        )}
      </td>
    );
  };

  const priceCell = (row) => {
    const { dataItem } = row;

    return <td>{`${dataItem.total} лв.`}</td>;
  };

  const getDiffs = async (id) => {
    const res = await FnbApi.getDiffsForConsolidation(id);
    if (res.status === StatusCodes.OK) {
      const add = res.data.filter((x) => x.type === 'AddToOrder');
      setAddPendingChanges(add);
      const remove = res.data.filter((x) => x.type === 'RemoveFromOrder');
      setRemovePendingChanges(remove);
    }
  };

  const UpdateTable = () => {
    stateRef?.current?.update();
  };

  useEffect(() => {
    getDiffs(orderId);
  }, []);

  return (
    <WhitePad isFluid>
      <TitleComponent
        isBig
        onLeftHandler={history.goBack}
        title={`Fnb Orders for Consolidation`}
        onRightHandler={(): void => {
          const win = window.open(`/orders/print/${orderId}`, '_blank');
          win?.focus();
        }}
        titleRight="Print Receipts"
      />
      <SecondaryButton
        size="xs"
        onClick={(): void => {
          window.location.href = `/orders/print-lot-report/${orderId}`;
        }}
        title="Print Lot Report"
      />
      <OrderChangesWrapper>
        <div>
          {addPendingChanges?.map((diff) => (
            <FnbPendingChange pendingChange={diff} />
          ))}
        </div>
        {removePendingChanges?.map((diff) => (
          <FnbPendingChange pendingChange={diff} />
        ))}
      </OrderChangesWrapper>
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="status" title="Status" cell={statusCell} />
          <GridColumn field="orderDate" title="Date" cell={CreatedOnCell} filter='date'/>
          <GridColumn field="uniqueNumber" title="FNB #" cell={numberCell} />
          <GridColumn field="order.orderNumber" title="Svila #" cell={orderNumberCell} />
          <GridColumn field="name" title="Клиент" />
          <GridColumn field="nameLast" title="Клиент" />
          <GridColumn field="paymentMethodTxt" title="Метод на плащане" />
          <GridColumn field="shCityName" title="Град за доставка" />
          <GridColumn field="total" title="Сума" cell={priceCell} />
          <GridColumn field='consolidated' title="Actions" cell={actionCell} filter="boolean" filterCell={ConsolidationFilter}/>
          <GridColumn field="isPacked" title="Packed" filter="boolean" filterCell={PackageFilter}/>
          <GridColumn field="fnbItemReservationStatus" title="Reservation Status" />
          <GridColumn field="problem" title="Problem" />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}

const OrderChangesWrapper = styled.div`
  margin: 30px 0;
`;
